import React from 'react';

export default function PageHero({ title, subtitle, label }) {
  return (
    <section className="relative pt-32 pb-16 sm:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-cmic-800 via-cmic-700 to-cmic-600" />
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-cmic-300 rounded-full blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {label && (
          <span className="inline-block text-sm font-semibold text-cmic-200 tracking-wider uppercase mb-3">
            {label}
          </span>
        )}
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4" data-testid="page-hero-title">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg text-cmic-100 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 60" fill="none" className="w-full">
          <path
            d="M0 60L60 55C120 50 240 40 360 35C480 30 600 30 720 32.5C840 35 960 40 1080 42.5C1200 45 1320 45 1380 45L1440 45V60H0Z"
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
}
